import { z } from "zod";
import { UuidSchema, MoneySchema, EpochMillisSchema } from "./common.js";
import { RarityRefSchema } from "./rarity.js";
import { InventoryItemSchema } from "./inventory.js";
/** Hôtel des ventes (R19, /api/market). Source : etheria_market (cols de recherche dénormalisées). */
export const MarketListingSchema = z.object({
    id: z.number().int(),
    sellerUuid: UuidSchema,
    sellerName: z.string().nullable(),
    category: z.string().nullable(),
    material: z.string(),
    itemId: z.string().nullable(),
    rarity: RarityRefSchema.nullable(),
    amount: z.number().int().positive(),
    price: MoneySchema,
    priceSort: z.number().int(),
    createdAt: EpochMillisSchema,
    expiresAt: EpochMillisSchema.nullable(),
    /** état : en vente / vendu / à réclamer / expiré. */
    status: z.enum(["ACTIVE", "SOLD", "CLAIMABLE", "EXPIRED"]),
    /** item sérialisé complet (§7.4) pour la fiche/tooltip. */
    item: InventoryItemSchema.nullable(),
});
/** Requête de recherche HDV (R19). */
export const MarketQuerySchema = z.object({
    category: z.string().optional(),
    rarity: z.string().optional(),
    material: z.string().optional(),
    min: z.number().nonnegative().optional(),
    max: z.number().nonnegative().optional(),
    q: z.string().optional(),
    seller: UuidSchema.optional(),
    limit: z.number().int().min(1).max(200).default(50),
    offset: z.number().int().min(0).default(0),
});
//# sourceMappingURL=market.js.map